export const STORAGE = {
    UI_THEME: 'theme',
    USER_ID: 'user_id',
    USER_EMAIL: 'user_email',
    USER_NAME: 'user_name',
    USER_ROLE: 'user_role',
    IS_ADMIN: 'user_is_admin',
    PARTICIPANT_ROLE: 'participant_role',
    COMPANY_ID: 'company_id',
    PARTICIPANT_INVITE_CODE: 'participant_invite_code',
    PARTICIPANT_INVITE_MADE_ACCOUNT: 'participant_invite_made_account',
    CREATE_PROGRAM_STEP: 'create_program_step',
    CREATE_PROGRAM_DATA: 'create_program_data',
    CREATE_PROGRAM_TEMP: 'create_program_temp'
}

export function setStorage(key, value) {
    localStorage.setItem(key, JSON.stringify(value))
}

export function getStorage(key) {
    let val = localStorage.getItem(key) 
    try { return JSON.parse(val) }
    catch { return val }
}

export function clearStorage(keys) {
    keys.forEach(key => {
        localStorage.removeItem(key)
    })
}

export function clearUserData() {
    clearStorage([STORAGE.USER_ID, STORAGE.USER_ROLE, STORAGE.PARTICIPANT_ROLE, STORAGE.USER_EMAIL, STORAGE.USER_NAME, STORAGE.COMPANY_ID])
}

export function clearCreateProgram() {
    clearStorage([STORAGE.CREATE_PROGRAM_STEP, STORAGE.CREATE_PROGRAM_DATA])
}